<template>
  <div>
    <TheNavigation :toggled-mobile-menu="toggledMobileMenu"
                   @toggle-mobile-menu="toggleMobileMenu"/>
    <TheMain>
      <slot/>
    </TheMain>
    <TheSubFooter :next-route="$options.nextRoute"/>
    <TheFooter/>
  </div>
</template>

<script>
import TheSubFooter from '@/components/footer/TheSubFooter';
import TheMain from '@/components/main/TheMain';
import TheFooter from '@/components/footer/TheFooter';
import TheNavigation from '@/components/navigation/TheNavigation';
import router from '@/router';
import debounce from 'lodash/debounce';

const delta = 5;
const navPersists = 680;

export default {
  name: 'DefaultPage',
  components: {
    TheSubFooter,
    TheMain,
    TheFooter,
    TheNavigation
  },
  props: {
    sections: Array
  },
  data: function () {
    return {
      lastScrollTop: 0,
      toggledMobileMenu: false
    };
  },
  watch: {
    $route () {
      this.scrollByRoute();
    }
  },
  created () {
    const allRoutes = router.options.routes;
    const currentRouteIndex = allRoutes.findIndex(
      element => element.name === this.$route.name
    );
    let nextRouteIndex = currentRouteIndex + 1;
    if (nextRouteIndex === allRoutes.length) nextRouteIndex = 0;
    this.$options.nextRoute = allRoutes[nextRouteIndex];
    this.$options.nextRoute.index = nextRouteIndex;

    this.handleDebouncedScroll = debounce(this.handleScroll, 50);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  mounted () {
    setTimeout(() => {
      this.scrollByRoute();
    }, 50);
  },
  methods: {
    toggleMobileMenu: function () {
      this.toggledMobileMenu = !this.toggledMobileMenu;
    },
    scrollByRoute: function () {
      const element = this.$route.hash;
      const animationOptions = {};
      /* eslint-disable */
      const scrollingElement = $('html, body');
      if (element && !$(element).is("section:first-of-type")) {
        animationOptions.scrollTop = $(element).offset().top;
      } else if (scrollingElement.scrollTop() > 0) {
        scrollingElement.scrollTop(0);
        return;
      }
      scrollingElement.animate(animationOptions, 300);
      /* eslint-enable */
    },
    handleScroll: function () {
      /* eslint-disable */
      const top = $(window).scrollTop();
      if (Math.abs(this.lastScrollTop - top) <= delta) return;
      // Conditionally show the nav
      if (top > this.lastScrollTop && top > delta && top > navPersists) { // Scroll Down
        $('#nav').removeClass('up');
        if (this.toggledMobileMenu) this.toggleMobileMenu();
      } else {
        $('#nav').addClass('up');
      }
      /* eslint-enable */
      this.lastScrollTop = top;
    }
  }
};
</script>
